import React, { useState, useEffect } from "react";
import { graphql } from "gatsby";

import routes from "../../clhbid-routes";

import { getStartTime, getSaleCountdown } from "../helpers/sale";

import useSaleStatuses from "../hooks/use-sale-statuses";

import Button from "./Button";

const SaleCountdownButton: React.FC<{
  sale: Queries.SaleCountdownButtonSaleFragment;
}> = ({ sale }) => {
  const [countdown, setCountdown] = useState(
    getSaleCountdown(
      new Date(getStartTime(sale)).getTime(),
      new Date().getTime()
    )
  );
  const { [sale.slug]: saleStatus } = useSaleStatuses();

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown(
        getSaleCountdown(
          new Date(getStartTime(sale)).getTime(),
          new Date().getTime()
        )
      );
    }, 100);

    return () => clearInterval(interval);
  }, [countdown, sale]);

  const buttonValues = {
    upcoming: `Bidding Starts In ${countdown}`,
    live: `View Bidding • Selling Now`,
    completed: `View Results • Completed`,
  };

  return (
    <Button external href={routes.sale.bidding(sale)}>
      {buttonValues[saleStatus]}
    </Button>
  );
};

export const SaleCountdownButtonFragment = graphql`
  fragment SaleCountdownButtonSale on ContentfulSale {
    slug
    parcels {
      enBloc
      startTime
    }
  }
`;

export default SaleCountdownButton;
